import validator from "./validator";
import {TextField} from "../../styles/config";
import {Formik} from "formik";
import React from "react";
import {MenuItem} from "@material-ui/core";
import LanguageFields from "../settings/translations/languages";
import Translate from "../../utils/utils";

const Form = ({initialValues, createResource, updateResource, isCreatingResource, closeModal, languages, isLoading, isSuccess, groups, categories, isFlower, moduleItem, moduleName}) => {

    const isTouched = (values) => {
        return !Object.is(initialValues, values);
    };

    return (
        <Formik
            initialValues={initialValues}
            validate={(obj) => {
                validator.validate(obj, isFlower)
            }}
            onSubmit={isCreatingResource() ? createResource : updateResource}
            enableReinitialize={true}
        >
            {({
                  values,
                  status,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
              }) => (
                <form onSubmit={handleSubmit} className="kt-form">
                    {status && (
                        <div role="alert" className={`alert ${isSuccess ? 'alert-success' : 'alert-danger'}`}>
                            <div className="alert-text">{status}</div>
                        </div>
                    )}
                    <TextField
                        disabled={!isCreatingResource() || isSubmitting}
                        select
                        margin="dense"
                        variant="outlined"
                        label={<Translate id="DIALOG.FORM.CATEGORY"/>}
                        fullWidth={true}
                        name="category_id"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values?.category_id ?? moduleItem?.category_id ?? ''}
                        helpertext={isTouched(values) && errors?.category_id}
                        error={Boolean(isTouched(values) && errors?.category_id)}
                    >
                        {categories.filter(category => {
                            if (isFlower) {
                                return category.slug.toLowerCase().includes('flower');
                            }
                            return category.slug.toLowerCase().includes('plant');
                        }).map(category => (

                            <MenuItem key={category.id} value={category.id}>
                                {category.name}
                            </MenuItem>
                        ))}

                    </TextField>

                    <TextField
                        margin="dense"
                        variant="outlined"
                        disabled={isSubmitting}
                        label={<Translate id="DIALOG.FORM.CODE"/>}
                        fullWidth={true}
                        name="code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values?.code ?? moduleItem?.code ?? ''}
                        helpertext={isTouched(values) && errors?.code}
                        error={Boolean(isTouched(values) && errors?.code)}
                    >

                    </TextField>

                    {isFlower &&
                    <TextField
                        select
                        margin="dense"
                        variant="outlined"
                        disabled={isSubmitting}
                        label={<Translate id="DIALOG.FORM.GROUP"/>}
                        fullWidth={true}
                        name="group_id"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values?.group_id ?? moduleItem?.group_id ?? ''}
                        helpertext={isTouched(values) && errors?.group_id}
                        error={Boolean(isTouched(values) && errors?.group_id)}
                    >
                        {groups.map(group => (

                            <MenuItem key={group.id} value={group.id}>
                                {group.name}
                            </MenuItem>
                        ))}

                    </TextField>}

                    <LanguageFields handleChange={handleChange} isLoading={isLoading} errors={errors}
                                    handleBlur={handleBlur} initialValues={initialValues} languages={languages}
                                    touched={touched} values={values} moduleName={moduleName}/>

                    <div className="kt-add-user__actions">
                        <button
                            type="submit"
                            disabled={isSubmitting || !isTouched(values)}
                            className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}

                        >
                            {isCreatingResource() ?
                                <Translate id={"DIALOG.FORM.BUTTON.SAVE"}/> :
                                <Translate id={"DIALOG.FORM.BUTTON.UPDATE"}/>}
                        </button>
                        <i
                            onClick={closeModal}
                            className={`btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary`}
                        >
                            <Translate id={"DIALOG.FORM.BUTTON.CLOSE"}/>
                        </i>
                    </div>
                </form>
            )}
        </Formik>
    )
}

export default Form;
